import React from "react";

const ActionLinks = (props) => <span className="action-link">{props.children}</span>;

export default ActionLinks;
